import { IThunkActionCreator } from '../../types/thunk';
import { createSimpleAction } from '../../containers/сonnectToDescriptors';
import { regionDescriptor } from '../../constants/descriptors';

export const setRegionFilter = (id: number): IThunkActionCreator => {
  return (dispatch) => {
    createSimpleAction(dispatch, regionDescriptor[0])(id);
  };
};
